export const SET_AVATARS = "SET_AVATARS";
